<template>
  <div id="instrument-equipment">

    <common-search :searchList="searchList" @onSearch="onSearch" :newKeyToName="keyToName"></common-search>

    <common-table
      :product_list="product_list"
      :loading="loading"
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders_orders"
      title="订单列表"
      type="orders"
      height="650"
      :newCheckHeader="checkedHeaders"
      :tableHandler="tableHandler"
      :newKeyToName="keyToName"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  name: 'instrument-equipment',
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  data() {
    return {
      userType: 4,
      product_list: null,
      searchList: {
        nickName: '',phone: '',orderNo: '',status: '',payTime: '',createdAt: '',
      },
      tableHandler: [

      ],
      checkedHeaders: ['用户昵称', '用户联系方式','订单号','微信交易单号','运单号','购买总金额','订单状态','订单创建时间','支付时间'],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      loading: false,
      newSearchList: null,
      keyToName: this.$commondata.KEY_TO_NAME_ORDERS,
    }
  },
  mounted(){
    this.userType = localStorage.getItem('userType');
    this.getMessageByPage();
  },
  methods: {
    async getMessageByPage(cb){
      this.loading = true;
      let _searchList = this.newSearchList ? this.newSearchList : this.searchList
      let options = this.$util.formatOptions(_searchList);
      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const product_list = await this.$request.get_message('orders',{page: this.currentPage,limit: this.pageSize,query: options});
      //console.log(product_list);
      if(product_list.code === 0){
        this.product_list = product_list.data;
        this.total = product_list.total;
      }else{
        this.$message(product_list.errMsg)
      }

      cb && cb(product_list.total);

      this.loading = false;
    },

    handleSizeChange(val) { //更改显示数据行数
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },

    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(val){
      this.$commondata.searchObj = this.searchList;
      this.newSearchList = Object.assign({}, this.searchList);
      if(val.price !== ''){
        this.newSearchList.price = val.price;
      }
      if(val.stock !== ''){
        this.newSearchList.stock = val.stock;
      }
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-equipment{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Orders.vue